module.exports = __webpack_public_path__ + "media/SlideShowVid2.71695d5d.mp4";